export const ADD_EXCH_BET = 'ADD_EXCH_BET';
export const REMOVE_EXCH_BET = 'REMOVE_EXCH_BET';
export const SET_EXCH_BET_STAKE = 'SET_EXCH_BET_STAKE';
export const CLEAR_EXCHANGE_BETS = 'CLEAR_EXCHANGE_BETS';
export const EXCH_BET_ODDS_CHANGE = 'EXCH_BET_ODDS_CHANGE';
// export const FETCH_OPEN_BETS_SUCCESS = 'FETCH_OPEN_BETS_SUCCESS';
export const FETCH_OPEN_BETS_CACHE_SUCCESS = 'FETCH_OPEN_BETS_CACHE_SUCCESS';
export const CLEAR_SUCCESS_BETS = 'CLEAR_SUCCESS_BETS';
